import React from "react";
import { Chip, Tooltip } from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { EVOKE_ROLES, USER_ROLES } from "static/constants";
import { NotificationsActive } from "@mui/icons-material";

const ReportStatus = ({
  reportDetail,
  currentUser,
  fileToAttachToReport,
  renderReportModifiedTooltipContent,
  data,
}) => {
  return (
    <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
      {reportDetail?.transmissionType && (
        <Tooltip
          title={`This is ${
            data?.transmissionType === "remote" ? "a remote" : "an in-office"
          } report`}
        >
          <Chip
            className="alert_status_chip_small"
            color="info"
            size="small"
            label={data?.transmissionType === "remote" ? "Remote" : "In-Office"}
          />
        </Tooltip>
      )}
      {(currentUser.role === USER_ROLES.ADMIN ||
        currentUser.role === USER_ROLES.USER ||
        currentUser.role === USER_ROLES.ASSISTANT) &&
        reportDetail?.billable && (
          <Tooltip title="This report is billable">
            <Chip
              label="Billable"
              size="small"
              className="alert_status_chip_small"
              style={{
                backgroundColor: "#4caf50",
                color: "#fff",
              }}
            />
          </Tooltip>
        )}
      {reportDetail?.alert_flag && (
        <Tooltip title="This report has an alert">
          <Chip
            label="Alert"
            color="error"
            size="small"
            className="alert_status_chip_small"
            style={{ backgroundColor: "#ef5350" }}
          />
        </Tooltip>
      )}
      {reportDetail?.warning_flag && (
        <Tooltip title="This report has a warning">
          <Chip
            className="alert_status_chip_small"
            label="Warning"
            color="warning"
            size="small"
            style={{ backgroundColor: "#ff9800" }}
          />
        </Tooltip>
      )}
      {fileToAttachToReport?.pageInsertFrom && (
        <Tooltip title={renderReportModifiedTooltipContent()}>
          <Chip
            className="alert_status_chip_small"
            color="info"
            size="small"
            label="Modified"
            variant="outlined"
            icon={
              <InfoOutlined
                style={{
                  order: 2,
                  marginLeft: "-7px",
                  marginRight: "5px",
                }}
              />
            }
          />
        </Tooltip>
      )}
      {EVOKE_ROLES.includes(currentUser?.role) &&
        reportDetail?.alert_notification_status === "success" && (
          <Tooltip title="Alert Sent">
            <Chip
              icon={<NotificationsActive />}
              className="alert_status_chip_small"
              color="success"
              size="small"
              variant="filled"
              label="Alert Sent"
            />
          </Tooltip>
        )}
    </div>
  );
};

export default ReportStatus;
